import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { AddCall } from 'src/providers/addvCall';
@Component({
  selector: 'app-popupalert',
  templateUrl: './popupalert.page.html',
  styleUrls: ['./popupalert.page.scss'],
})
export class PopupalertPage implements OnInit {
  dts: any;
  msg: any;
  sts: any;
  frm: any;
  fillbut: any;
  acceptbut: any;
  status: any;
  msgs: any;
  message: any;
  ticket: any;
  msgdata: any;
  revstatus: any;
  reviewmsg: any;

  constructor(
    public modalCtrl: ModalController,
    public addCall: AddCall
  ) {
    // this.msgdata = navParams.get('msgdata');
    // this.ticket = navParams.get('ticket');
  }

  ngOnInit() {
    console.log(this.msg);
    console.log(this.msgs);
    console.log(this.sts);
    console.log(this.frm);
    console.log(this.dts);
    console.log(this.status);
    console.log(this.message);

  }

  ionViewWillEnter() {

    console.log(this.status, "this.status");

    if (this.sts === 101) {
      this.msg = this.msg;
      console.log('check');
    } else {
      if (this.sts === 102) {
        this.msg = this.msg;
      }
      //  else if (this.status == "Review added successfully!") {
      //   this.message = this.status
      //   this.msgs = this.msgs
      // }
      else {
        this.msg = this.msg;
        this.msgdata = this.msgdata;
        this.ticket = this.ticket;
      }

    }
    this.fillbut = true;
    this.acceptbut = true;
  }


  okay(yes) {
    this.acceptbut = false;
    // console.log(typeof (this.sts), "==============================================================");

    if (this.sts === 3) {
      // console.log('cq1');
      this.modalCtrl.dismiss('nursebookinghistory');
    }
    else {
      console.log('cq2');
      this.modalCtrl.dismiss(yes);
    }
    // this.modalCtrl.dismiss(this.msg);


  }
  no(no) {
    this.fillbut = false;
    //this.modalCtrl.dismiss(this.msg,no);
    this.modalCtrl.dismiss(no);
  }

  NO(data) {
    this.modalCtrl.dismiss(data);
  }

  Yes(data) {
    this.modalCtrl.dismiss(data);
  }
}
